<app-symbol></app-symbol>
<app-widetext [class.collapse]="!showText"></app-widetext>
<!-- <app-text></app-text> -->
